import React, { useState } from 'react';
import { TabContent, TabPane, Form, Label } from 'reactstrap';
import '../../Contracts/MyContracts.scss';
import { useTranslation } from 'react-i18next';
import { Row, Col } from 'reactstrap';

import { ReactComponent as IconBuilding } from '../../../images/icn_buildings.svg';
import {
  BtnOutlineGreen,
  ContFilterYear,
  ContFlexRight,
  ContPaginationPage,
} from '../../../styled-components';
import FormGroup from 'reactstrap/lib/FormGroup';
import CustomInput from 'reactstrap/lib/CustomInput';

import SearchInput from '../../../commons/SearchInput';
import Footer from '../../../commons/Footer';
import Header from '../../../commons/Header';
import generatePaginationOptions from '../../../lib/helpers/generatePaginationOptions';
import ContractsTableEnergyTab from './ContractsTableEnergyTab';
import ModalConfirm from '../../../commons/ModalConfirm';
import ModalInvoiceDetail from '../../../commons/ModalInvoiceDetail';
import currency from 'currency.js';
import generateYearOptions from '../../../lib/helpers/generateYearOptions';
import generateMonthOptions from '../../../lib/helpers/generateMonthOptions';
import IafPolisImportFeedbackModal from './IafPolisImportFeedbackModal';

const EnergyPresentational = ({
  data,
  profile,
  query,
  total,
  onFilter,
  onCondoUpdate,
  onChangeAdmin,
  onExtendAdminManagement,
  checkVatCode,
  selectedContracts,
  onSelectChange,
  onInvoice,
  onSelectAll,
  selectedAll,
  onStatusChanged,
  onImportIafPolis,
  toggleShowImportIafPolisFeedback,
  iafPolisImportFeedbackData,
  hasImportedIafPolis,
  totPod = 0,
  totPdr = 0,
  handleFileListView,
}) => {
  const [t] = useTranslation('CONTRACTS');
  const { offset, limit, customerType, managementStatus, contractType } = query;

  const [modalState, setModalState] = useState({
    isOpen: false,
    selectedId: null,
  });
  const [totalContractsValue, setTotalContractsValue] = useState(0);

  function handleImportIafPolis(event) {
    const file = event.target?.files[0];
    const fileSize = (Number(file?.size || 0) / 1024 ** 2).toFixed(2);

    if (fileSize > 20) {
      window.alert('File troppo grande. Sono ammessi file di massimo 20MB');
      return;
    }

    const formData = new FormData();
    formData.append('file', file);
    onImportIafPolis(formData);
  }

  const onOpenModal = () => {
    const itemsForTotalValue = selectedContracts.map((_id) => {
      return data.find((contract) => contract._id === _id).contract_value;
    });
    let total = 0;
    itemsForTotalValue.forEach((value) => {
      total += value;
    });
    setTotalContractsValue(
      currency(total, { symbol: '€', precision: 2 }).format()
    );
  };

  return (
    <section>
      <TabContent activeTab={'1'}>
        <TabPane tabId="1">
          <IafPolisImportFeedbackModal
            data={iafPolisImportFeedbackData}
            toggle={toggleShowImportIafPolisFeedback}
            isOpen={hasImportedIafPolis}
          />

          <section>
            <Header
              title={t('PAGES:CONTRACTS')}
              icon={<IconBuilding fill="#ffffff" style={{ height: '25px' }} />}
            />

            <Row className="align-items-center">
              <Col className="">
                <ContFlexRight>
                  Contratti POD:&nbsp;<strong>{totPod}</strong>&nbsp; |
                  Contratti PDR:&nbsp;<strong>{totPdr}</strong>
                </ContFlexRight>
              </Col>
            </Row>

            <Row className="search-add-cont m-t-20" style={{ rowGap: '20px' }}>
              <Col sm="12" md="6" lg="3" className="select-wrapper">
                <ContFilterYear
                  className="no-width"
                  style={{ marginBottom: '0' }}
                >
                  <Row>
                    <Col xs="6">
                      <Label>{t('COMMON:TITLE_FILTER_ACTIVATION_YEAR')}</Label>
                    </Col>
                    <Col xs="6">
                      <FormGroup>
                        <CustomInput
                          type="select"
                          id="selectcontractActivationYear"
                          name="contractActivationYear"
                          value={query && query.contractActivationYear}
                          onChange={({
                            target: { value: contractActivationYear },
                          }) => {
                            onFilter({ contractActivationYear });
                          }}
                        >
                          {generateYearOptions(true)}
                        </CustomInput>
                      </FormGroup>
                    </Col>
                  </Row>
                </ContFilterYear>
              </Col>

              <Col sm="12" md="6" lg="3" className="select-wrapper">
                <ContFilterYear
                  className="no-width"
                  style={{ marginBottom: '0' }}
                >
                  <Row>
                    <Col xs="6">
                      <Label>{t('COMMON:TITLE_FILTER_ACTIVATION_MONTH')}</Label>
                    </Col>
                    <Col xs="6">
                      <FormGroup>
                        <CustomInput
                          type="select"
                          id="contractActivationMonth"
                          name="contractActivationMonth"
                          disabled={!query.contractActivationYear}
                          value={query && query.contractActivationMonth}
                          onChange={({
                            target: { value: contractActivationMonth },
                          }) => onFilter({ contractActivationMonth })}
                        >
                          {generateMonthOptions()}
                        </CustomInput>
                      </FormGroup>
                    </Col>
                  </Row>
                </ContFilterYear>
              </Col>
              {!(profile && profile._id) && (
                <Col sm="6" md="6" lg="3" xl="3">
                  <SearchInput
                    query={{ search: query && query.admin }}
                    onFilter={({ search }) => onFilter({ admin: search })}
                    label={t('SEARCH:ADMINISTRATOR')}
                  />
                </Col>
              )}
              <Col sm="6" md="6" lg="3" xl="3">
                <SearchInput
                  query={{ search: query && query.customer }}
                  onFilter={({ search }) => onFilter({ customer: search })}
                  label={t('SEARCH:CUSTOMER')}
                />
              </Col>
              <Col sm="6" md="6" lg="3" xl="3">
                <SearchInput
                  query={{ search: query && query.pod_pdr }}
                  onFilter={({ search }) => onFilter({ pod_pdr: search })}
                  label={t('SEARCH:POD_PDR')}
                />
              </Col>
              <Col sm="6" md="6" lg="3" xl="3">
                <SearchInput
                  query={{ search: query && query.condo_vat_cf }}
                  onFilter={({ search }) => onFilter({ condo_vat_cf: search })}
                  label={t('SEARCH:CLIENT_VAT_CODE')}
                />
              </Col>
              <Col sm="6" md="6" lg="3" xl="3">
                <SearchInput
                  query={{ search: query && query.owner }}
                  onFilter={({ search }) => onFilter({ owner: search })}
                  label={t('SEARCH:OWNER')}
                />
              </Col>

              <Col sm="6" md="6" lg="3" xl="3">
                <SearchInput
                  query={{ search: query && query.holder }}
                  onFilter={({ search }) => onFilter({ holder: search })}
                  label={t('SEARCH:HOLDER_FEE')}
                />
              </Col>
              <Col sm="12" md="4" lg="3" xl="3" className="select-wrapper">
                <ContFilterYear
                  className="no-width"
                  style={{ marginBottom: '0' }}
                >
                  <Row>
                    <Col xs="6">
                      <Label>Tipo cliente</Label>
                    </Col>
                    <Col xs="6">
                      <FormGroup>
                        <CustomInput
                          type="select"
                          id="customerType"
                          name="customerType"
                          value={customerType}
                          onChange={({ target: { value: customerType } }) =>
                            onFilter({ customerType })
                          }
                        >
                          <option value="" defaultChecked>
                            Tutti
                          </option>
                          <option value="condos">Condomini</option>
                          <option value="customerExtra">Clienti privati</option>
                          <option value="utilizers">Utilizzatori</option>
                        </CustomInput>
                      </FormGroup>
                    </Col>
                  </Row>
                </ContFilterYear>
              </Col>
              <Col sm="12" md="4" lg="3" xl="3" className="select-wrapper">
                <ContFilterYear
                  className="no-width"
                  style={{ marginBottom: '0' }}
                >
                  <Row>
                    <Col xs="6">
                      <Label>Stato Gestione</Label>
                    </Col>
                    <Col xs="6">
                      <FormGroup>
                        <CustomInput
                          type="select"
                          id="managementStatus"
                          name="managementStatus"
                          value={managementStatus}
                          onChange={({ target: { value: managementStatus } }) =>
                            onFilter({ managementStatus })
                          }
                        >
                          <option value="" defaultChecked>
                            Tutti
                          </option>
                          <option value="active">ATTIVO</option>
                          <option value="terminated">TERMINATO</option>
                        </CustomInput>
                      </FormGroup>
                    </Col>
                  </Row>
                </ContFilterYear>
              </Col>
              <Col sm="12" md="4" lg="3" xl="3" className="select-wrapper">
                <ContFilterYear
                  className="no-width"
                  style={{ marginBottom: '0' }}
                >
                  <Row>
                    <Col xs="6">
                      <Label>Tipo contratto</Label>
                    </Col>
                    <Col xs="6">
                      <FormGroup>
                        <CustomInput
                          type="select"
                          id="contractType"
                          name="contractType"
                          value={contractType}
                          onChange={({ target: { value: contractType } }) =>
                            onFilter({ contractType })
                          }
                        >
                          <option value="" defaultChecked>
                            Tutti
                          </option>
                          <option value="POD">POD</option>
                          <option value="PDR">PDR</option>
                        </CustomInput>
                      </FormGroup>
                    </Col>
                  </Row>
                </ContFilterYear>
              </Col>
              {profile.polis === true && (
                <Col sm="12" md="4" lg="4">
                  <ContFilterYear className="no-width select-wrapper">
                    <Row>
                      <Col xs="6">
                        <Label>{t('CONTACTS:IAF_POLIS_FILTER')}</Label>
                      </Col>
                      <Col xs="6">
                        <FormGroup>
                          <CustomInput
                            type="select"
                            id="selectIafPolis"
                            name="iafPolis"
                            value={query.iafPolis || ''}
                            onChange={(e) =>
                              onFilter({ iafPolis: e.target.value })
                            }
                          >
                            <option value="">Tutti</option>
                            <option value="true">SI</option>
                            <option value="false">NO</option>
                          </CustomInput>
                        </FormGroup>
                      </Col>
                    </Row>
                  </ContFilterYear>
                </Col>
              )}

              {profile.polis === true && (
                <Col sm="12" md="6" lg="3">
                  <FormGroup>
                    <CustomInput
                      type="file"
                      id="importIafPolis"
                      name="importIafPolis"
                      onChange={handleImportIafPolis}
                      accept=".xlsx"
                    />
                    <Label for="importIafPolis">
                      {t('ENERGY_CONTRACT:CHOOSE_FILE_IAF_POLIS')}
                      &nbsp;({t('ENERGY_CONTRACT:MAX_UPLOAD_FILE_SIZE')})
                    </Label>
                  </FormGroup>
                </Col>
              )}
            </Row>
          </section>

          <section className="m-t-20">
            <ContractsTableEnergyTab
              data={data}
              profileType={profile.type}
              total={total}
              offset={offset}
              limit={limit}
              onFilter={onFilter}
              onCondoUpdate={onCondoUpdate}
              onChangeAdmin={onChangeAdmin}
              profile={profile}
              onExtendAdminManagement={onExtendAdminManagement}
              truncateTable={profile && profile._id}
              checkVatCode={checkVatCode}
              selectedContracts={selectedContracts}
              onSelectChange={onSelectChange}
              onSelectAll={onSelectAll}
              selectedAll={selectedAll}
              setModalState={setModalState}
              handleFileListView={handleFileListView}
            />

            <ContPaginationPage>
              <p>{t('COMMON:PAGINATION_PER_PAGE')}</p>

              <FormGroup>
                <CustomInput
                  type="select"
                  className="pagination-select"
                  id="perPage"
                  name="perPage"
                  value={limit}
                  onChange={({ target: { value: limit } }) => {
                    onFilter({ limit: limit });
                  }}
                >
                  {generatePaginationOptions()}
                </CustomInput>
              </FormGroup>
            </ContPaginationPage>

            <ModalInvoiceDetail
              modalState={modalState}
              setModalState={setModalState}
              onStatusChanged={onStatusChanged}
            />

            <ContFlexRight className="mt-5">
              {selectedContracts.length > 0 && (
                <ModalConfirm
                  onConfirm={() => {
                    onInvoice();
                  }}
                  onOpen={onOpenModal}
                  text={
                    `Il valore totale dei contratti é: ${totalContractsValue} ` +
                    '\n' +
                    t('CONTACTS:CONFIRM_INVOICE')
                  }
                >
                  <BtnOutlineGreen type="button" className="uppercase">
                    FATTURA SELEZIONATI
                  </BtnOutlineGreen>
                </ModalConfirm>
              )}
            </ContFlexRight>
          </section>
          <Footer />
        </TabPane>
      </TabContent>
    </section>
  );
};

export default EnergyPresentational;
